"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'forums-users' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 69 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'forums-users' });
    }
    ;
    /**
    * @typedef {Object} forumSettingsShowHeaderParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - on/off (default - on)
    * @property {string} origin - main page / post page
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: show header. Evid: 42.
     * Event description: When the user clicks on toggle in layout-> show header.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: on/off (default - on)
     *
     * origin - Type: string. Desc: main page / post page
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsShowHeaderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowHeader = function (params) {
        return this.bi.log(__assign({ evid: 42 }, params));
    };
    /**
    * @typedef {Object} clickOnLinkParams
    * @property {string} comment_id - comment id (if exists)
    * @property {GUID} instance_id - null
    * @property {string} link - url
    * @property {GUID} biToken - null
    * @property {string} origin - post/comment/reply
    * @property {string} post_id - post id
    **/
    /**
     * Name: Click on link. Evid: 16.
     * Event description: When the user clicks on a link in a post/comment/reply.
    
     * comment_id - Type: string. Desc: comment id (if exists)
     *
     * instance_id - Type: guid.
     *
     * link - Type: string. Desc: url
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post/comment/reply
     *
     * post_id - Type: string. Desc: post id
     * @param {clickOnLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnLink = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} postLoadedParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post loaded. Evid: 26.
     * Event description: When a post is loaded.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postLoaded = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} followAllCategoriesWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {string} type - 'follow' /'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Follow all categories Wix App. Evid: 61.
     * Event description: Event triggered when in "All Categories" pressing 'Follow'/'Unfollow' makes you follow/unfollow all categories.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: 'follow' /'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followAllCategoriesWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followAllCategoriesWixApp = function (params) {
        return this.bi.log(__assign({ evid: 61 }, params));
    };
    /**
    * @typedef {Object} forumAddPanelForumElementAddedParams
    * @property {string} element_type - recent post /
    * @property {GUID} instance_id - null
    * @property {string} layout - vertical/vertical_with_stats/horizontal/horizontal_with_stats
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Forum add panel - forum element added. Evid: 57.
     * Event description: triggered when adding forum element from the forum in add panel.
    
     * element_type - Type: string. Desc: recent post /
     *
     * instance_id - Type: guid.
     *
     * layout - Type: string. Desc: vertical/vertical_with_stats/horizontal/horizontal_with_stats
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     * @param {forumAddPanelForumElementAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumAddPanelForumElementAdded = function (params) {
        return this.bi.log(__assign({ evid: 57 }, params));
    };
    /**
    * @typedef {Object} followCategoryWixAppParams
    * @property {GUID} app_id - app_id
    * @property {string} category_followed - the category_id that had been followed
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {string} origin - 'category_list'/'category_picker_inside_category'/'menu_inside_category'
    * @property {string} type - 'follow' /'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: follow category Wix App. Evid: 58.
     * Event description: Event triggered when clicking on follow category button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * category_followed - Type: string. Desc: the category_id that had been followed
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: 'category_list'/'category_picker_inside_category'/'menu_inside_category'
     *
     * type - Type: string. Desc: 'follow' /'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followCategoryWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followCategoryWixApp = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    /**
    * @typedef {Object} forumSettingsFontParams
    * @property {string} font - selected font
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} place - post title / post description / header title / header description
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: font. Evid: 52.
     * Event description: When font is selected.
    
     * font - Type: string. Desc: selected font
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * place - Type: string. Desc: post title / post description / header title / header description
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsFontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsFont = function (params) {
        return this.bi.log(__assign({ evid: 52 }, params));
    };
    /**
    * @typedef {Object} followPostWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {string} origin - search_results, user_profile
    * @property {GUID} owner_id - uuid of post owner
    * @property {string} post_followed - the post_id that had been followed
    * @property {string} type - 'follow'/'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Follow post Wix App. Evid: 59.
     * Event description: Event triggered when clicking on follow post in 3 dots menu.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: search_results, user_profile
     *
     * owner_id - Type: guid. Desc: uuid of post owner
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * type - Type: string. Desc: 'follow'/'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followPostWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followPostWixApp = function (params) {
        return this.bi.log(__assign({ evid: 59 }, params));
    };
    /**
    * @typedef {Object} forumSettingsInputParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - known also as bIToken
    * @property {string} setting_input_json - JSON object with all properties
    **/
    /**
     * Name: forum settings input. Evid: 12.
     * Event description: Event triggered when users saves/publishes his site. with all the latest settings he chose.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: known also as bIToken
     *
     * setting_input_json - Type: string. Desc: JSON object with all properties
     * @param {forumSettingsInputParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsInput = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} postClickOnShareParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - post share button / action button
    * @property {string} post_id - post id
    * @property {string} type - post/comment/reply
    **/
    /**
     * Name: Post - click on share. Evid: 38.
     * Event description: When the user clicks on "share" to share post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post share button / action button
     *
     * post_id - Type: string. Desc: post id
     *
     * type - Type: string. Desc: post/comment/reply
     * @param {postClickOnShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnShare = function (params) {
        return this.bi.log(__assign({ evid: 38 }, params));
    };
    /**
    * @typedef {Object} clickOnPostForPostCommentAndReplyParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} type - (post,comment,reply)
    **/
    /**
     * Name: Click on post (for post, comment and reply). Evid: 24.
     * Event description: When the user clicks "post" on post, comment and reply.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * type - Type: string. Desc: (post,comment,reply)
     * @param {clickOnPostForPostCommentAndReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnPostForPostCommentAndReply = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} commentThreeDotsActionButtonParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} value - the option chosen - (view profile, like comment etc)
    **/
    /**
     * Name: Comment - three dots - action button. Evid: 22.
     * Event description: When the user clicks on action button from the menu opened from pressing on the three dots on a comment.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * value - Type: string. Desc: the option chosen - (view profile, like comment etc)
     * @param {commentThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} forumSettingsCommunitySettingsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: community settings. Evid: 50.
     * Event description: When toggle is switched on/off.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsCommunitySettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsCommunitySettings = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} commentReportedWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {GUID} owner_id - uuid of post owner
    * @property {string} post_followed - the post_id that had been followed
    * @property {string} type - 'spam'/'violence'/'harrasment'/'nudity or sexual activity'/'other'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Comment reported - Wix App. Evid: 60.
     * Event description: Event triggered when a comment is reported in Wix App.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of post owner
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * type - Type: string. Desc: 'spam'/'violence'/'harrasment'/'nudity or sexual activity'/'other'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {commentReportedWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentReportedWixApp = function (params) {
        return this.bi.log(__assign({ evid: 60 }, params));
    };
    /**
    * @typedef {Object} forumLoadInEditorSuccessParams
    * @property {GUID} instance_id - Intance id of the specific Forum instance
    * @property {GUID} biToken - Metasite guid
    **/
    /**
     * Name: Forum load in Editor success. Evid: 62.
     * Event description: Forum was loaded in the editor successfully.
    
     * instance_id - Type: guid. Desc: Intance id of the specific Forum instance
     *
     * biToken - Type: guid. Desc: Metasite guid
     * @param {forumLoadInEditorSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumLoadInEditorSuccess = function (params) {
        return this.bi.log(__assign({ evid: 62 }, params));
    };
    /**
    * @typedef {Object} categoriesCreateNewCategoryCreateParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category created
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Categories - create new category - create. Evid: 31.
     * Event description: When the user clicks on create in the create new category page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category created
     *
     * type - Type: string. Desc: category/subcategory
     * @param {categoriesCreateNewCategoryCreateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesCreateNewCategoryCreate = function (params) {
        return this.bi.log(__assign({ evid: 31 }, params));
    };
    /**
    * @typedef {Object} forumSettingsLoginFromForumMenuParams
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: login from forum menu. Evid: 45.
     * Event description: When user switch toggle.
    
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsLoginFromForumMenuParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsLoginFromForumMenu = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} clickOnAddGifParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} type - comment/post/reply
    **/
    /**
     * Name: Click on Add GIF. Evid: 25.
     * Event description: When the user clicks on add GIF in a comment/post/reply.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * type - Type: string. Desc: comment/post/reply
     * @param {clickOnAddGifParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnAddGif = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} postClickOnMapParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - click on map. Evid: 37.
     * Event description: When the user clicks on map or location in a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postClickOnMapParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnMap = function (params) {
        return this.bi.log(__assign({ evid: 37 }, params));
    };
    /**
    * @typedef {Object} forumMemberSignupSettingsBecomingAMemberParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - Everyone/People I approve
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum member signup settings: becoming a member. Evid: 46.
     * Event description: When user change who can be a member.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: Everyone/People I approve
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumMemberSignupSettingsBecomingAMemberParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumMemberSignupSettingsBecomingAMember = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} commentDeletedParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: comment deleted. Evid: 40.
     * Event description: When comment is deleted successfully.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {commentDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentDeleted = function (params) {
        return this.bi.log(__assign({ evid: 40 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPickForumSubjectParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type_of_subject - type of subject which user chose
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: pick forum subject. Evid: 41.
     * Event description: When user clicks on subject name.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type_of_subject - Type: string. Desc: type of subject which user chose
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsPickForumSubjectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPickForumSubject = function (params) {
        return this.bi.log(__assign({ evid: 41 }, params));
    };
    /**
    * @typedef {Object} newItemAddedParams
    * @property {GUID} instance_id - null
    * @property {string} item - Link/mention/image/gif
    * @property {GUID} biToken - null
    * @property {string} type - Post/comment/reply
    **/
    /**
     * Name: New item added. Evid: 36.
     * Event description: When a new item (link/mention/image/gif) was added to post/comment/reply.
    
     * instance_id - Type: guid.
     *
     * item - Type: string. Desc: Link/mention/image/gif
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: Post/comment/reply
     * @param {newItemAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newItemAdded = function (params) {
        return this.bi.log(__assign({ evid: 36 }, params));
    };
    /**
    * @typedef {Object} categoriesEditCategorySaveParams
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {boolean} isChanged - if the user has changed anything
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Categories - Edit category - save. Evid: 32.
     * Event description: When the user clicks save in the edit category page.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * isChanged - Type: bool. Desc: if the user has changed anything
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * type - Type: string. Desc: category/subcategory
     * @param {categoriesEditCategorySaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesEditCategorySave = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} forumSettingsShowNewPostsParams
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - on/off (default - on)
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: show new posts. Evid: 64.
     * Event description: When the user clicks on toggle in layout-> show new posts.
    
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: on/off (default - on)
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsShowNewPostsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowNewPosts = function (params) {
        return this.bi.log(__assign({ evid: 64 }, params));
    };
    /**
    * @typedef {Object} categoryNewCategoryAddedParams
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {string} type - category - can only be category at creation time
    **/
    /**
     * Name: Category - new category added. Evid: 33.
     * Event description: When new category was added successfully.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * type - Type: string. Desc: category - can only be category at creation time
     * @param {categoryNewCategoryAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoryNewCategoryAdded = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} postSharedSuccessfullyParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post shared successfully. Evid: 39.
     * Event description: When post shared successfully.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postSharedSuccessfullyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSharedSuccessfully = function (params) {
        return this.bi.log(__assign({ evid: 39 }, params));
    };
    /**
    * @typedef {Object} categoriesCategoryDeletedParams
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {string} place - unused
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Categories - category deleted. Evid: 34.
     * Event description: When a category is deleted successfully.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * place - Type: string. Desc: unused
     *
     * type - Type: string. Desc: category/subcategory
     * @param {categoriesCategoryDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesCategoryDeleted = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} memberSignupSettingsSwitchedSettingsPageParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} page_name - General/Social&community/Policies
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Member signup settings: switched settings page. Evid: 48.
     * Event description: When user switch member signup settings page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * page_name - Type: string. Desc: General/Social&community/Policies
     *
     * uuid - Type: guid. Desc: uuid
     * @param {memberSignupSettingsSwitchedSettingsPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.memberSignupSettingsSwitchedSettingsPage = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} forumSettingsShowSubcategoriesParams
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - on/off (default - off)
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: show subcategories. Evid: 63.
     * Event description: When the user clicks on toggle in layout-> show subcategories.
    
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: on/off (default - off)
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsShowSubcategoriesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowSubcategories = function (params) {
        return this.bi.log(__assign({ evid: 63 }, params));
    };
    /**
    * @typedef {Object} categoryThreeDotsActionButtonParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - (manage forum, feed etc)
    * @property {string} type - category/subcategory
    * @property {string} value - name of the action button clicked
    **/
    /**
     * Name: Category - three dots - action button. Evid: 28.
     * Event description: When the user clicks on one of the action buttons in three dots  menu on one of the categories.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: (manage forum, feed etc)
     *
     * type - Type: string. Desc: category/subcategory
     *
     * value - Type: string. Desc: name of the action button clicked
     * @param {categoryThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoryThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 28 }, params));
    };
    /**
    * @typedef {Object} postClickOnReactionParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - owner/member
    * @property {string} target - comment, post, reply
    * @property {string} type - type of reaction (emoji, heart)
    **/
    /**
     * Name: Post - click on reaction. Evid: 14.
     * Event description: When the user clicks on reactions icon to add reaction.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: owner/member
     *
     * target - Type: string. Desc: comment, post, reply
     *
     * type - Type: string. Desc: type of reaction (emoji, heart)
     * @param {postClickOnReactionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnReaction = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} forumMemberSignupSettingsWhichOptionShowsFirstParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - New member signup/Existing member login
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum member signup settings: which option shows first. Evid: 47.
     * Event description: When first option is changed.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: New member signup/Existing member login
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumMemberSignupSettingsWhichOptionShowsFirstParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumMemberSignupSettingsWhichOptionShowsFirst = function (params) {
        return this.bi.log(__assign({ evid: 47 }, params));
    };
    /**
    * @typedef {Object} forumFeedOptionsParams
    * @property {string} activity_type - views counter/filtered hashtags/social sharing options
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum feed options. Evid: 44.
     * Event description: When user sets which information can be seen on forum feed.
    
     * activity_type - Type: string. Desc: views counter/filtered hashtags/social sharing options
     *
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumFeedOptionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumFeedOptions = function (params) {
        return this.bi.log(__assign({ evid: 44 }, params));
    };
    /**
    * @typedef {Object} manageForumSettingsToggleParams
    * @property {string} currentValue - current value of the toggle
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} targetValue - target value of the toggle
    **/
    /**
     * Name: Manage forum - settings - toggle. Evid: 30.
     * Event description: When the user clicks on the toggle between start with categories (Yes/no).
    
     * currentValue - Type: string. Desc: current value of the toggle
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * targetValue - Type: string. Desc: target value of the toggle
     * @param {manageForumSettingsToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumSettingsToggle = function (params) {
        return this.bi.log(__assign({ evid: 30 }, params));
    };
    /**
    * @typedef {Object} oneAppForumDisplaySettingsParams
    * @property {string} application_id - OneApp / Web
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - list of posts / list of categories
    * @property {GUID} ownerId - owner id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: OneApp -> forum display settings. Evid: 54.
     * Event description: When the user selects forum display: list of posts / list of categories.
    
     * application_id - Type: string. Desc: OneApp / Web
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: list of posts / list of categories
     *
     * ownerId - Type: guid. Desc: owner id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {oneAppForumDisplaySettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppForumDisplaySettings = function (params) {
        return this.bi.log(__assign({ evid: 54 }, params));
    };
    /**
    * @typedef {Object} forumLayoutHeaderHeightParams
    * @property {number} height - chosen height
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - main page/posts page
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum layout: header height. Evid: 43.
     * Event description: When the user changes header height.
    
     * height - Type: numeric. Desc: chosen height
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: main page/posts page
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumLayoutHeaderHeightParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumLayoutHeaderHeight = function (params) {
        return this.bi.log(__assign({ evid: 43 }, params));
    };
    /**
    * @typedef {Object} forumSettingsAllowSocialLoginParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} socialNetwork - Google+/Facebook
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: allow social login. Evid: 49.
     * Event description: When user switch toggle next to social page name.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * socialNetwork - Type: string. Desc: Google+/Facebook
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsAllowSocialLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsAllowSocialLogin = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} manageForumCreateNewCategoryParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Manage forum - create new category. Evid: 29.
     * Event description: When the user clicks to create new category in the manage forum page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: category/subcategory
     * @param {manageForumCreateNewCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumCreateNewCategory = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} postClickToCommentParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - owner/member
    **/
    /**
     * Name: Post - click to comment. Evid: 15.
     * Event description: When the user clicks on "comment" to add comment.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: owner/member
     * @param {postClickToCommentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickToComment = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} manageForumLoadedParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Manage Forum - loaded. Evid: 27.
     * Event description: When manage forum page is loaded in OneApp.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {manageForumLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumLoaded = function (params) {
        return this.bi.log(__assign({ evid: 27 }, params));
    };
    /**
    * @typedef {Object} categoriesMakeCategoryToSubcategoryOrViceVersaParams
    * @property {string} applicationType - OneApp / Web
    * @property {string} category_id - category id
    * @property {GUID} instance_id - null
    * @property {string} method - three_dot / drag
    * @property {GUID} biToken - null
    * @property {string} origin - live_site /editor/manage ("manage" is relevant for OneApp)
    * @property {GUID} subcategory_id - subcategory id
    * @property {string} type - type before change: category/subcategory
    * @property {string} type_chosen - category/subcategory
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Categories - make category to subcategory or vice versa. Evid: 55.
     * Event description: When the user makes category to subcategory or vice versa.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid.
     *
     * method - Type: string. Desc: three_dot / drag
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: live_site /editor/manage ("manage" is relevant for OneApp)
     *
     * subcategory_id - Type: guid. Desc: subcategory id
     *
     * type - Type: string. Desc: type before change: category/subcategory
     *
     * type_chosen - Type: string. Desc: category/subcategory
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {categoriesMakeCategoryToSubcategoryOrViceVersaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesMakeCategoryToSubcategoryOrViceVersa = function (params) {
        return this.bi.log(__assign({ evid: 55 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPoliciesParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} policyType - Terms of use page / Privacy policy / Code of conduct page
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: policies. Evid: 51.
     * Event description: When toggle is switched on/off.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * policyType - Type: string. Desc: Terms of use page / Privacy policy / Code of conduct page
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsPoliciesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPolicies = function (params) {
        return this.bi.log(__assign({ evid: 51 }, params));
    };
    /**
    * @typedef {Object} forumSettingsFontSizeParams
    * @property {string} fontSize - font size
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} place - post title / post description / header title / header description
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: font size. Evid: 53.
     * Event description: When font size is selected.
    
     * fontSize - Type: string. Desc: font size
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * place - Type: string. Desc: post title / post description / header title / header description
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsFontSizeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsFontSize = function (params) {
        return this.bi.log(__assign({ evid: 53 }, params));
    };
    /**
    * @typedef {Object} forumPageViewParams
    * @property {string} application_id - Unused
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Forum page view. Evid: 56.
     * Event description: When forum view is loaded in web or OneApp.
    
     * application_id - Type: string. Desc: Unused
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {forumPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumPageView = function (params) {
        return this.bi.log(__assign({ evid: 56 }, params));
    };
    /**
    * @typedef {Object} postClickOnCommentsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - click on comments. Evid: 18.
     * Event description: When the user clicks on comments to view all the comments.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postClickOnCommentsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnComments = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} newPostClickNextParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: New post - click next. Evid: 35.
     * Event description: When the user clicks next in the new post page in order to choose category.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {newPostClickNextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newPostClickNext = function (params) {
        return this.bi.log(__assign({ evid: 35 }, params));
    };
    /**
    * @typedef {Object} postClickOnReactionsParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - click on reactions. Evid: 17.
     * Event description: Click on reactions in a post to view reactions list.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postClickOnReactionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnReactions = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} addPhotoParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - (post,comment,reply)
    * @property {string} post_id - post id
    **/
    /**
     * Name: Add photo. Evid: 23.
     * Event description: When the user clicks to add photo.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: (post,comment,reply)
     *
     * post_id - Type: string. Desc: post id
     * @param {addPhotoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addPhoto = function (params) {
        return this.bi.log(__assign({ evid: 23 }, params));
    };
    /**
    * @typedef {Object} mentionsMentionsSuggestionsListMemberClickedParams
    * @property {string} comment_id - deprecated
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - deprecated
    **/
    /**
     * Name: mention suggestions member selected. Evid: 21.
     * Event description: When a user clicks one user from the mentioned list.
    
     * comment_id - Type: string. Desc: deprecated
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: deprecated
     * @param {mentionsMentionsSuggestionsListMemberClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionsMentionsSuggestionsListMemberClicked = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} postCommentClickOnReplyParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - comment - click on reply. Evid: 19.
     * Event description: When the user clicks on reply to comment.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postCommentClickOnReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postCommentClickOnReply = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} mentionsMentionsSuggestionsListOpenedParams
    * @property {string} comment_id - deprecated
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - deprecated
    * @property {string} role - deprecated
    * @property {string} type - comment/ reply/post
    **/
    /**
     * Name: mentions suggestions list opened. Evid: 20.
     * Event description: When a user added '@' from top bar or from keyboard and the suggestions list opened.
    
     * comment_id - Type: string. Desc: deprecated
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: deprecated
     *
     * role - Type: string. Desc: deprecated
     *
     * type - Type: string. Desc: comment/ reply/post
     * @param {mentionsMentionsSuggestionsListOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionsMentionsSuggestionsListOpened = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} postThreeDotsActionButtonParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - (owner/member)
    * @property {string} value - value of the button chosen
    **/
    /**
     * Name: Post - three dots - action button. Evid: 13.
     * Event description: When a user chooses an action button from the menu opened from clicking on the three dots on a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: (owner/member)
     *
     * value - Type: string. Desc: value of the button chosen
     * @param {postThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map